var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-header",
            {
              staticStyle: {
                padding: "0 0 16px 0",
                height: "auto",
                "background-color": "#101010"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { staticClass: "left-centered", attrs: { span: 12 } },
                    [
                      _c("img", {
                        staticStyle: { width: "101px", height: "41px" },
                        attrs: { src: require("../../assets/logo.png") },
                        on: { click: _vm.redirectToHome }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "right-centered", attrs: { span: 12 } },
                    [
                      _c("img", {
                        attrs: { src: require("../../assets/menu-alt-1.png") },
                        on: { click: _vm.spread }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { padding: "0", overflow: "visible" } },
            [
              _c("breadcrumb-reset-password"),
              _vm._v(" "),
              _c("reset-success-section"),
              _vm._v(" "),
              _c("agent-sign-in-section"),
              _vm._v(" "),
              _c("property-icon-set")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c315a950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c315a950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reset/passwordResetSuccessfulLayout.vue
// module id = null
// module chunks = 